import { useStyletron } from 'baseui'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverride, toObjectOverride } from 'baseui/helpers/overrides';
import { Icon, IconProps } from 'baseui/icon';
import { h } from 'preact';
import { forwardRef } from 'preact/compat';

export enum HasWifi {
    YES = 'has wifi',
    NO = 'no wifi',
    UNKNOWN = 'unknown',
}

export default forwardRef<SVGSVGElement, IconProps & { status: HasWifi }>((props: IconProps & {
    status: HasWifi
}, ref) => {
    const [, theme] = useStyletron();
    const { size, color, overrides = {}, ...restProps } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const SvgOverride = mergeOverride( // @ts-ignore
        { component: theme.icons?.Wifi ? theme.icons.Wifi : null },
        overrides?.Svg ? toObjectOverride(overrides.Svg) : {},
    );

    let content;
    switch (props.status) {
    case HasWifi.YES:
        content = <path d="m254 710-84-86q59-59 138.5-93.5T480 496q92 0 171.5 35T790 626l-84 84q-44-44-102-69t-124-25q-66 0-124 25t-102 69ZM84 540 0 456q92-94 215-147t265-53q142 0 265 53t215 147l-84 84q-77-77-178.5-120.5T480 376q-116 0-217.5 43.5T84 540Zm396 396 141-142q-27-27-63-42.5T480 736q-42 0-78 15.5T339 794l141 142Z" />;
        break;
    case HasWifi.NO:
        content = <path d="M876 540q-77-77-178.5-120.5T480 376q-21 0-40.5 1.5T400 382L298 280q44-12 89.5-18t92.5-6q142 0 265 53t215 145l-84 86ZM716 698l-29-29-29-29-144-144q81 8 151.5 41T790 624l-74 74Zm74 302L414 622q-47 11-87.5 33T254 710l-84-86q32-32 69-56t79-42l-90-90q-41 21-76.5 46.5T84 540L0 454q32-32 66.5-57.5T140 348l-84-84 56-56 736 736-58 56Zm-310-64L339 794q27-27 63-42.5t78-15.5q42 0 78 15.5t63 42.5L480 936Z" />;
        break;
    case HasWifi.UNKNOWN:
        content = <path d="M480 936 0 456q95-97 219.5-148.5T480 256q136 0 260.5 51.5T960 456l-40 40q-28-36-69.5-58T760 416q-83 0-141.5 58.5T560 616q0 49 22 90.5t58 69.5L480 936Zm280-40q-17 0-29.5-12.5T718 854q0-17 12.5-29.5T760 812q17 0 29.5 12.5T802 854q0 17-12.5 29.5T760 896Zm-30-128q0-38 10-59t43-54q21-21 27-31.5t6-26.5q0-18-14-31.5T765 552q-21 0-39 13.5T700 602l-54-22q12-38 44-61t75-23q49 0 80 29t31 74q0 23-10 41t-38 46q-24 24-30 38.5t-6 43.5h-62Z" />;
        break;
    }
    return (
        <Icon viewBox="0 96 960 960"
              ref={ref}
              title={props.status}
              size={size}
              color={color}
              overrides={{ Svg: SvgOverride }}
              {...restProps}>
            {content}
        </Icon>
    );
});
